import axios from "axios";

// Dynamically determine API base URL
const getApiBaseUrl = () => {
  // If explicitly set via env var, use that
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname;

  // Localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api';
  }

  // Subdomain of profile2connect.com (e.g., username.profile2connect.com)
  // API should go to main domain
  if (hostname.endsWith('.profile2connect.com')) {
    return 'https://profile2connect.com/api';
  }

  // Main domain or custom domain - use same origin
  return `${window.location.origin}/api`;
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

// ✅ Attach Token in Requests (skip for registration endpoint)
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    // Check if the URL includes the registration endpoint
    if (token && !config.url.includes("/users/register/")) {
      config.headers.Authorization = `Token ${token}`; // Use Django Token Auth format
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Handle Expired Token (or 401 Unauthorized responses)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Check if we're on a subdomain (public profile) - don't redirect to login
      const hostname = window.location.hostname;
      const isSubdomain = hostname.match(/^([^.]+)\.profile2connect\.com$/) &&
                          !hostname.startsWith('www.');

      // Also check if this is a public API endpoint - don't redirect for public routes
      const isPublicEndpoint = error.config?.url?.includes('/public/') ||
                               error.config?.url?.includes('/home/public/');

      if (!isSubdomain && !isPublicEndpoint) {
        console.error("🚨 Token expired or unauthorized. Redirecting to login...");
        localStorage.removeItem("token"); // Remove the invalid token
        window.location.href = "/login"; // Redirect to login page
      }
    }
    return Promise.reject(error);
  }
);

export default api;
